// ** React Imports
import { Fragment } from 'react'

// ** Dropdowns Imports
import UserDropdown from './UserDropdown'

// ** Third Party Components

// ** Reactstrap Imports
import NotificationDropdown from './NotificationDropdown'
import IntlDropdown from "./IntlDropdown";

const NavbarUser = props => {
  // ** Props
  const { skin, setSkin } = props

  // ** Function to toggle Theme (Light/Dark)

  return (
    <Fragment>
      {/* <div className='bookmark-wrapper d-flex align-items-center'>
        <NavItem className='d-none d-lg-block'>
          <NavLink className='nav-link-style'>
            <ThemeToggler />
          </NavLink>
        </NavItem>
      </div> */}
      <ul className='nav navbar-nav align-items-center ms-auto'>
        <IntlDropdown />
        {/*<NotificationDropdown></NotificationDropdown>*/}
        <UserDropdown />
      </ul>
    </Fragment>
  )
}
export default NavbarUser
